// returns the values for the group by as per user's OKR accesses
import { useMemo } from 'react';

import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import { INSIGHT_VIEWS } from 'reducers/okrsPageSlice';

export const useOKRGroupByValues = () => {
  const { moduleName } = useOrganisationSettings();

  const updatedInsightViews = useMemo(() => [...INSIGHT_VIEWS], []);

  const memoizedOptions = useMemo(() => {
    const options = [];
    options.push({
      label: moduleName,
      value: updatedInsightViews[1].value,
    });

    options.push(INSIGHT_VIEWS[0]);

    return options;
  }, [moduleName, updatedInsightViews]);

  return memoizedOptions;
};
